import {IBaseLookup} from "./Ibase.lookup";

export namespace Status {

    export const lookupName: string = "Status";

    export interface Status {
			statusKey: number;
			name: string;
			description: string;
			endPoint: string;
			hl7Code: string;
			dicomStatus: string;
			type: string;
			lastUpdated: Date;
			timeThresholdCheck: string;
			draggedBehavior: number;
			dragLinked: number;
			coreStatus: number;
			iconKey: number;
			active?: string; //only for web bundle
			color?: string;
			alternateColor?: string;
		}

    export interface StatusDraggedBehavior {
        statusDraggedBehaviorKey: number;
        name: string;
        description: string;
        longDescription: string;
    }

    export interface StatusDragLinked {
        statusDragLinkedKey: number;
        name: string;
        description: string;
        longDescription: string;
    }

    export interface StatusDS extends IBaseLookup {
        status: Status[];
        statusDraggedBehavior: StatusDraggedBehavior[];
        statusDragLinked: StatusDragLinked[];
    }
}
